import * as Routes from 'constants/Routes'
import { injectReducer } from 'common/reducers'

export default store => ({
  path: Routes.CONTROL_PANEL,
  getComponent: async function (nextState, cb) {
    const [module, reducer] = await Promise.all([
      import('./containers/ControlPanelContainer'),
      import('./reducers')
    ])

    injectReducer(store, { key: 'controlPanel', reducer: reducer.default })

    cb(null, module.default)
  }
})
